import UsersProfileContainer from "../../../../Components/Applications/Users/UsersProfile/UsersProfileContainer";

const UsersProfile = () => {
  return <UsersProfileContainer />;
};

export default UsersProfile;
